import { InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";

const ChangeMerchantPwdDialog = ({ merchant, open, onClose }) => {
  const [form, setForm] = useState({
    passwordNew: "",
    passwordNew2: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    const { passwordNew, passwordNew2 } = form;
    if (passwordNew !== passwordNew2) return alert("两次密码不一致");

    const { msg } = await asyncRequest({
      path: "/merchant/changePwd",
      data: {
        mid: merchant.mid,
        password: passwordNew,
      },
    });

    setForm({
      passwordNew: "",
      passwordNew2: "",
    });
    alert(msg, "success");
    onClose();
  }

  return (
    <FormDialog title="重置商户密码" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="管理员">
        <TextField fullWidth disabled value={merchant.realname || merchant.username} size="small" />
      </FormItem>
      <FormItem title="登录账号">
        <TextField fullWidth disabled value={merchant.username} size="small" />
      </FormItem>

      <FormItem title="新密码">
        <TextField
          fullWidth
          type="password"
          placeholder="新密码"
          autoComplete="off"
          id="passwordNew"
          value={form.passwordNew}
          size="small"
          inputProps={{
            startAdornment: <InputAdornment position="start">kg</InputAdornment>,
          }}
          onChange={(e) => handleIptChange("passwordNew", e.target.value)}
        />
      </FormItem>

      <FormItem title="确认密码">
        <TextField fullWidth type="password" placeholder="确认密码" autoComplete="off" id="passwordNew2" value={form.passwordNew2} size="small" onChange={(e) => handleIptChange("passwordNew2", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChangeMerchantPwdDialog;
